import { useQuery } from '@tanstack/react-query';
import { userControllerGetSelfTenants } from '@/generated/korza-api-client';

export function useEnrolledTenants() {
  return useQuery({
    queryKey: ['enrolled-tenants'],
    queryFn: async () => {
      const result = await userControllerGetSelfTenants();
      if (result.error || !result.data) {
        throw new Error('Failed to get enrolled tenants: ' + result.error);
      }
      return result.data;
    },
  });
}
